import Repository from "../../repository";

export default {
    Add: (payload) => Repository.post(`/api/BlackLists/Add`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/BlackLists/ChangeStatus`, payload),
    Delete: (payload) => Repository.post(`/api/BlackLists/Delete`, payload),
    Edit: (payload) => Repository.post(`/api/BlackLists/Edit`, payload),
    Get: (payload) => Repository.post(`/api/BlackLists/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/BlackLists/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/BlackLists/GetById`, payload),
}
